export const initSideNavToggle = () => {
  const closeSub = (el) => {
    el.style.height = el.scrollHeight + 'px';
    requestAnimationFrame(() => {
      el.style.height = '0';
    });
  };

  const openSub = (el) => {
    el.style.height = el.scrollHeight + 'px';
    el.addEventListener('transitionend', () => {
      el.style.height = 'auto';
    }, { once: true });
  };

  // SP: サイドナビ全体のトグル（「アリケイス.jp」クリック）
  const header = document.querySelector('.js-side-nav-header');
  const list = document.querySelector('.side-nav.-other .list');

  if (header && list) {
    header.addEventListener('click', () => {
      const isOpen = header.classList.contains('-active');
      if (isOpen) {
        header.classList.remove('-active');
        closeSub(list);
      } else {
        header.classList.add('-active');
        openSub(list);
      }
    });
  }

  // 各アコーディオンアイテムのトグル
  const toggles = document.querySelectorAll('.js-side-nav-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const sub = toggle.nextElementSibling;
      if (!sub) return;
      const isOpen = toggle.classList.contains('-active');

      // 他を閉じる
      toggles.forEach(other => {
        if (other !== toggle && other.classList.contains('-active')) {
          other.classList.remove('-active');
          const otherSub = other.nextElementSibling;
          if (otherSub) closeSub(otherSub);
        }
      });

      // トグル
      if (isOpen) {
        toggle.classList.remove('-active');
        closeSub(sub);
      } else {
        toggle.classList.add('-active');
        openSub(sub);
      }
    });
  });
};
